import type React from "react"
import { useEffect, useState } from "react"
import { PaymentsService } from "../client"

interface PaymentSuccessParams {
  session_id: string
}

const PaymentSuccess: React.FC<PaymentSuccessParams> = ({ session_id }) => {
  const [sessionId, setSessionId] = useState<string | null>(null)

  useEffect(() => {
    const fetchSession = async () => {
      try {
        const session = await PaymentsService.success({
          sessionId: session_id,
        })
        setSessionId((session as any).id)
      } catch (error) {
        console.error("Failed reading session.", error)
      }
    }

    fetchSession()
  }, [])

  if (!sessionId) {
    return <div>Loading...</div>
  }

  return (
    <div>
      <h1>Payment Success</h1>

      <p>
        Your order was placed successfully. An email confirmation and receipt
        should arrive in your inbox shortly. A member of the ProCircular team
        will be in touch within 1 business day to coordinate your purchased
        services.
      </p>

      <p>
        Please include this transaction code when requesting assistance:{" "}
        {sessionId.toString()}
      </p>
    </div>
  )
}

export default PaymentSuccess
